import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';

import { ResponseConfirmProductsReceiving } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-product-receiving',
  templateUrl: './edit-product-receiving.component.html',
  styleUrls: ['./edit-product-receiving.component.css'],
})
export class EditProductReceivingComponent implements OnInit {
  @ViewChild('locations') locationsSelect: MatSelect
  textoResultado: any;
  ArrayLocations = [];
  isLDT=false
  constructor(
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private formbuider: FormBuilder,
    public dialogRef: MatDialogRef<EditProductReceivingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ArrayLocations = [];
	if (this.authenticationService.currentUserValue.company=='LDT20') {
		this.isLDT=true;
	}
  }

  ngOnInit(): void {
    this.OnSelectLocations(this.data.Location);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  Oneditar(respuesta: ResponseConfirmProductsReceiving) {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['id'] = Number(respuesta.id);
    Request['itemNumber'] = String(respuesta.ItemNumber);
    Request['lotNumber'] = String(respuesta.LotNumber);
    Request['itemDescription'] = String(respuesta.ItemDescription);
    Request['statedQuantity'] = String(respuesta.StatedQuantity);
    Request['tblLocationID'] = Number(respuesta.LocationID);
    console.log(Request);

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProductsEditAddProduct`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((response: any) => {
        this.textoResultado = response.responses;
      });
  }
  OnSelectLocations(search:any) {
var ss=String(search)

if (ss=="") {
  

    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(search)}`,
       
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: any) => {
        this.ArrayLocations = response;
      });
    } else {
  if (ss.length>3) {
    this._httpClient
    .get<any>(
      `${environment.apiUrl}/Administracion/SearchLocationsNew?companyId=${Number(this.authenticationService.currentUserValue.companyIdWh)}&active=1&search=${String(search)}`,
     
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token,
        }),
      }
    )
    .subscribe((response: any) => {
      this.ArrayLocations = response;
      this.locationsSelect.open();
    });
  } else {
    
  }
    }
  }
  applyFilterLocation (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
  
this.OnSelectLocations(filterValue.trim().toLowerCase())
   
  }
}
